///<reference path='../../typings/index.d.ts' />
///<reference path='playbutton.ts' />

module agi.expressions.card.layer {
    import Config = agi.expressions.card.Config;
    import Event = agi.expressions.event.Event;
    import AssetManifest = agi.expressions.card.manifest.AssetManifest;

    export class EndReplayButton extends PlayButton{
        constructor(
            container:HTMLElement, 
            measuringContainer:HTMLElement, 
            assets:AssetManifest
        ){
            super(container, measuringContainer,assets);
        }

        public init(){
            super.init();
            this.playButton.style.width = "135px";
            this.playButton.style.height = "60px";
            this.playButton.style.top = "475px";
            this.playButton.style.left = "218px";       
            this.element.id = 'expression-replay-button-container';
            this.playButtonImg.src = this.assets.playButtonURLs.end;
        }

    }
}